<template>
  <div>
    <div class="search-box">
      <div class="input-item">
        <span class="label">海报名称</span>
        <Input v-model="searchParams.title" clearable placeholder="请输入" />
      </div>
      <div class="input-item">
        <span class="label">关联产品</span>
        <Select :label-in-value="true" v-model="searchParams.productCode" placeholder="请选择" filterable clearable multiple>
          <Option :value="product.productCode" v-for="product in productListArr" :key="product.id">{{ product.productName }}</Option>
        </Select>
      </div>
      <div class="input-item">
        <span class="label">发布时间</span>
        <DatePicker
          type="daterange"
          split-panels
          separator="至"
          :transfer="true"
          placement="bottom"
          format="yyyy-MM-dd"
          placeholder="选择日期"
          :value="searchParams.date"
          @on-change="searchParams.date = $event"
        ></DatePicker>
      </div>
      <div class="btn-item">
        <Button type="primary" @click="searchAjax">查询</Button>
        <Button type="primary" class="btn-reset" ghost @click="resetSearch()">重置</Button>
      </div>
    </div>

    <div class="tab-one">
      <Tabs v-model="activeTab" @on-click="changeTabOne">
        <TabPane :label="item.name + '(' + item.counts + ')'" :name="item.id" v-for="(item, i) in tabOneList" :key="i"></TabPane>
      </Tabs>
    </div>

    <div class="tab-two" v-if="tabTwoList.length">
      <div class="tab-item" v-for="(item, index) in tabTwoList" :key="index" :class="{ active: tabTwoAction == index }" @click="changeTabTwo(item, index)">
        <span>{{ item.name }}</span>
      </div>
    </div>

    <!-- 批量操作栏 -->
    <div class="batchOperation" v-if="tableData.length">
      <div class="checkBoxList">
        <Checkbox class="checkBox" :disabled="isAll" v-model="isOnePage" @on-change="handleCheck">当前页海报</Checkbox>
        <Checkbox class="checkBox" v-model="isAll" @on-change="handleCheckAll">全部海报</Checkbox>
        <div class="quantity">
          已选择 <span style="color: #236dff">{{ isAll ? total : checkItemsList.length }}</span> 项
        </div>
      </div>
      <div v-if="$units.pointAction('content_6_1')">
        <Button type="primary" ghost @click="batchImport()">批量导入</Button>
      </div>
    </div>

    <loading :isShow="listLoading" />
    <no-data v-if="tableData.length == 0"></no-data>
    <div class="contentList" v-else>
      <div
        v-for="(item, index) in tableData"
        :key="index"
        class="posterList"
        @mouseleave="control = false"
        @click.stop="item.isImport == 0 && !isAll && selectedItem(item)"
      >
        <div class="poster">
          <img :class="{ 'active-item': item.isImport == 0 && item._checked }" :src="item.materials[0].materialUrl" />
          <div class="check-group" v-if="item.isImport == 0">
            <Checkbox v-model="item._checked" :disabled="item._disabled" @on-change="handleCheckItem($event, item)"></Checkbox>
          </div>
          <div class="posterEdit">
            <img src="@static/images/product/Twriting.png" alt="" v-if="item.copyWriter" @click.stop="openWriting(item)" />
            <img src="@static/images/product/openImg.png" alt="" @click.stop="openImport(item, [item.id])" />
            <span class="import-btn" v-if="$units.pointAction('content_6_1')&&item.isImport == '0'" @click.stop="$refs.importPosterRef.open(item, [item.id])">导入</span>
            <span class="import-btn grey" v-else>已导入</span>
          </div>
          <div class="posterContent">
            <!-- <span>导入数：{{ item.importNums }}</span> -->
            <span>发布时间：{{ item.publishTime }}</span>
          </div>
        </div>
        <div class="posterTitle">
          <span class="title">{{ item.title }}</span>
          <img v-if="getTime(item.publishTime)" src="@/static/images/contentManage/09.png">
        </div>
      </div>
    </div>
    <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="pageChange" style="text-align: center" />

    <!-- 复制文案 -->
    <Modal v-model="visibleWriting" :mask-closable="false" :footer-hide="true" class="my-modal top">
      <div class="writingTitle">{{ writingData.title }}</div>
      <div class="writingContent" v-if="writingData.copyWriter">{{ writingData.copyWriter }}</div>
      <div class="ivu-modal-footer">
        <Button type="primary" @click="copywrite(writingData.copyWriter)">复制文案</Button>
        <Button type="text" @click="visibleWriting = false">返回</Button>
      </div>
    </Modal>

    <!-- 导入弹窗 -->
    <Modal v-model="visibleImport" :mask-closable="false" :footer-hide="true" class="my-modal top" width="390px">
      <div class="import-container">
        <div class="import-title">
          {{ importItem.title }}
        </div>
        <div class="img">
          <img :src="importItem.materials && importItem.materials[0].materialUrl" preview="id" />
        </div>
      </div>

      <div class="ivu-modal-footer">
        <Button type="primary" v-if="importItem.isImport == 0" @click="$refs.importPosterRef.open(importItem, importItemId)">导入</Button>
        <Button type="primary" v-else :disabled="true">已导入</Button>
      </div>
    </Modal>

    <!-- 导入 -->
    <posterMaterialImport
      ref="importPosterRef"
      @success="searchAjax(), visibleImport = false;
    "
    ></posterMaterialImport>
  </div>
</template>

<script>
import { pageTool } from '@/api/mixins';
import { filterTime } from '@/api/filter';
import posterMaterialImport from './posterMaterialImport';

export default {
  mixins: [pageTool],
  components: {
    posterMaterialImport
  },
  mounted() {
    // 组件加载完成后，打印方法和属性
    this.$preview.on('imageLoadComplete', (e, item) => {
      this.$preview.self.options.bgOpacity = 0.5;
    });
    //异步插入的图片，数据更新后更新视图
    this.$previewRefresh();
  },
  data() {
    return {
      tableLoading: false, //表格loading
      searchParams: {},
      tableData: [],
      activeTab: '',
      tabOneList: [],
      tabTwoList: [],
      productListArr: [],
      tabTwoAction: 0,
      tabTwoActionId: '',
      total: 0,
      pageNo: 1,
      pageSize: 12,
      control: false,
      visibleWriting: false,
      writingData: {},
      checkAllGroup: [],
      isOnePage: false,
      isAll: false,
      totalNum: 0,
      allId: [],
      visibleImport: false,
      importItem: {},
      importItemId: [],
      checkItemsList:[]
    };
  },
  methods: {
    async getData() {
      this.getProductList();
      await this.getClassArr(true);
      this.activeTab = this.tabOneList[0].id;
      this.tabTwoAction = 0;
      this.getList();
    },

    getTime(time) {
      let nowdate = filterTime(new Date(), 'YYYY-MM-DD');
      if(filterTime(time, 'YYYY-MM-DD') == nowdate) {
        return true
      }else{
        return false
      }
    },

    // 搜索
    searchAjax() {
      this.pageNum = 1;
      this.isAll = false;
      this.checkAllGroup = [];
      this.checkItemsList = [];
      this.isOnePage = false;
      this.getList();
      this.getClassArr(false);
    },

    // 重置 
    async resetSearch() {
      this.searchParams = {}
      this.searchParams.date = [];      
      this.pageNum = 1;
      this.tabTwoActionId = this.activeTab;
      
      this.$http({
        url: '/buz/cms/materialsLibrary/columnTree/2',
        type: 'POST',
        data: {
          ...this.getParams()
        }
      }).then(res => {
        this.tabOneList = res.data;
      });     
      this.getList();       
    },

    // 获取列表参数
    getParams() {
      const params = Object.assign({}, this.searchParams);
      if (params.date && params.date.length) {
        params.startTime = params.date[0] && filterTime(params.date[0], 'YYYY-MM-DD');
        params.endTime = params.date[1] && filterTime(params.date[1], 'YYYY-MM-DD');
        delete params.date;
      } else {
        delete params.date;
      }
      return params;
    },

    // 产品
    getProductList() {
      this.$http({
        url: '/buz/productBase/read/short/list',
        type: 'POST',
        data: {
          pageNo: 1,
          pageSize: 9999
        }
      }).then(res => {
        this.productListArr = res.data;
      });
    },

    // tab分类
    getClassArr(query) {
      return this.$http({
        url: '/buz/cms/materialsLibrary/columnTree/2',
        type: 'POST',
        data: {
          ...this.getParams()
        }
      }).then(res => {
        this.tabOneList = res.data;
        if (res.data && res.data[0].children) {
          if (query) {
            this.tabTwoList = res.data[0].children;
            this.tabTwoActionId = this.tabTwoList[0].id;
          }
        } else {
          this.tabTwoActionId = res.data[0].id;
        }
      });
    },

    getList() {
      this.listLoading = true;
      this.$http({
        url: '/buz/cms/materialsLibrary/queryPosterPage',
        type: 'POST',
        data: {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          columnIds: [this.tabTwoActionId],
          ...this.getParams()
        }
      })
        .then(res => {
          this.checkItemsList.forEach(item1=>{
            res.data.map(item2=>{
              if(item2.id == item1.id) {
                item2._checked = true;
              }
            })
          })
          // 统计当前页选中的个数
          let checkPageLeng = res.data.filter(item=>item._checked).length;
          if(checkPageLeng == res.data.length){
            this.isOnePage = true;
          }

          this.tableData = res.data;
          this.total = res.total;
          this.totalNum = 0;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },

    // 切换一级分类
    changeTabOne(val) {
      this.isAll = false;
      this.checkAllGroup = [];
      this.checkItemsList = [];
      this.isOnePage = false;
      this.tabTwoList = [];
      this.tabTwoAction = 0;
      this.pageNum = 1;
      if (!val) {
        this.tabTwoActionId = '';
      } else {
        this.tabOneList.map(item => {
          if (item.id == val) {
            if (item.children && item.children.length) {
              this.tabTwoList = item.children;
              this.tabTwoActionId = item.children[0].id;
            } else {
              this.tabTwoList = [];
              this.tabTwoActionId = val;
            }
          }
        });
      }
      this.getList();
    },

    changeTabTwo(item, index) {
      this.tabTwoAction = index;
      this.tabTwoActionId = item.id;
      this.pageNum = 1;
      this.getList();
    },

    async pageChange(pageNum) {
      if (!this.isAll) {
        this.isOnePage = false;
        this.checkAllGroup = [];
      }
      this.pageNum = pageNum;
      this.getList();
    },

    // 打开复制文本
    openWriting(item) {
      this.visibleWriting = true;
      this.writingData = item;
    },

    // 文案复制
    copywrite(value) {
      let oInput = document.createElement('input');
      oInput.value = value;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand('Copy');
      oInput.remove();
      this.$Message.success('复制成功');
    },

    // 打开导入弹窗
    openImport(item, ids) {
      this.visibleImport = true;
      this.importItem = item;
      this.importItemId = ids;
    },

    // 点击选中当前图片
    selectedItem(item) {
      this.$set(item, '_checked', item._checked == undefined ? true : !item._checked);
      this.handleCheckItem(item._checked, item);
    },

    // 选中当前勾选框
    handleCheckItem(value, item) { 
      if(value) {
        this.checkAllGroup.push(item.id);
        // 把当前已选中的数据存放到数组中
        this.checkItemsList.push(item);
        // 获取当前页选中的个数
        let len = this.tableData.filter(item=>item._checked).length;
        if(len == this.tableData.length){
          this.isOnePage = true;
        }        
      }else{
        // 当前页选中数据不等于分页条页，去掉当前页选中
        this.checkAllGroup = this.checkAllGroup.filter(data => data != item.id);
        if(this.checkAllGroup.length != this.tableData.length){
          this.isOnePage = false;
        }
        // 从已选中删除掉当前去掉选中的数据
        this.checkItemsList = this.checkItemsList.filter(data => data.id != item.id);
      }
    },


    // 当前页海报
    handleCheck() {
      this.isAll = false;
      if(this.isOnePage) {
        const arr = this.tableData.filter(item => item.id&&item.isImport==0);
        this.checkAllGroup = arr.map(item => item.id);
        this.tableData.forEach(item => {
          item._checked = true;
        });
        // 获取当前页可导入id集合，并从已选数组中删除掉
        let tableListIds =  this.tableData.filter(item=>item.id&&item.isImport==0);
        // 获取所有已选的id
        let checkedIds = this.checkItemsList.map(item=>item.id);
        tableListIds.map(item=>{
          if(!checkedIds.includes(item.id)){
            this.checkItemsList.push(item);
          }
        })
      }else{
        this.checkAllGroup = [];
        this.tableData.forEach(item => {
          item._checked = false;
        });
        // 获取当前页id集合，并从已选数组中删除掉
        let tableListIds =  this.tableData.map(item=>item.id);
        this.checkItemsList = this.checkItemsList.filter(item=>!tableListIds.includes(item.id));
      }
    },

    // 取消全部
    cancleSelete() {
      this.isAll = false;
      this.isOnePage = false;
      this.totalNum = 0;
      this.checkAllGroup = [];
    },

    // 选中
    selectItem(item) {
      if (!this.checkAllGroup.includes(item.id) && item.isImport == 0) {
        this.checkAllGroup.push(item.id);
      } else {
        this.checkAllGroup = this.checkAllGroup.filter(data => data != item.id);
      }
    },

    // 批量导入
    batchImport() {
      if (!this.checkItemsList.length&&!this.isAll) {
        this.$notice.msg('请至少选择一个海报');
        return;
      }
      let ids = this.checkItemsList.map(item=>item.id);
      this.$refs.importPosterRef.open({}, this.isAll?this.allId:ids);
    },

    // 全选
    handleCheckAll() {
      this.isOnePage = this.isAll;
      const tableData = JSON.parse(JSON.stringify(this.tableData));
      tableData.forEach(item => {
        item._disabled = this.isAll;
        item._checked = this.isAll;
      });
      this.tableData = tableData;
      this.checkAllGroup = [];
      this.checkItemsList = [];
      if(this.isAll) {
        this.getAllPosterId();
      }
    },
    // 海报id
    getAllPosterId() {
      let startTime = '';
      let endTime = '';
      if (this.searchParams.date && this.searchParams.date.length > 0) {
        startTime = this.searchParams.date[0];
        endTime = this.searchParams.date[1];
      }
      this.$http({
        url: '/buz/cms/materialsLibrary/queryPosterList',
        type: 'POST',
        data: {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          title: this.searchParams.title,
          columnIds: [this.tabTwoActionId],
          productCode: this.searchParams.productCode,
          startTime,
          endTime
        }
      })
        .then(res => {
          this.allId = res.data;
        })
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/.pswp__bg {
  border: 1px solid red !important;
}
.tab-one {
  position: relative;
  /deep/.ivu-tabs-nav {
    max-width: 80%;
    overflow-x: auto;
  }
  /deep/ .ivu-tabs-tab-active {
    font-weight: bold;
  }
}

.tab-two {
  display: flex;
  margin-bottom: 15px;
  .tab-item {
    margin-right: 15px;
    padding: 7px 16px;
    background: #f5f7f9;
    border-radius: 2px;
    cursor: pointer;
    span {
      font-size: 12px;
      color: #727c8e;
    }
    &.active {
      background: #236dff;
      span {
        color: #ffffff;
      }
    }
  }
}
.batchOperation {
  padding-right: 20px;
  height: 50px;
  background: #f5f7f9;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .checkBoxList {
    margin-left: 20px;
    display: flex;

    .checkBox {
      margin-right: 30px;
      color: #3c464f;
      font-size: 13px;
    }

    .quantity {
      color: #727c8e;
      font-size: 12px;
    }

    .btn {
      font-size: 12px;
      color: #236dff;
      cursor: pointer;
      margin-left: 18px;
    }
  }
}
.contentList {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 30px;

  .posterList {
    margin-right: 30px;
    margin-top: 20px;
    margin-bottom: 35px;
    .poster {
      width: 240px;
      height: 426px;
      position: relative;
      &:hover .posterContent {
        display: block;
      }

      .posterContent {
        display: none;
        position: absolute;
        width: 240px;
        height: 40px;
        line-height: 40px;
        border-radius: 0px 0px 10px 10px;
        bottom: 0;
        right: 0;
        background: #000;
        opacity: 0.8;
        padding-left: 12px;

        span {
          color: #fff;
          font-size: 12px;
          font-family: PingFang SC;
        }
      }

      &:hover .posterEdit {
        display: block;
      }

      .posterEdit {
        display: none;
        position: absolute;
        top: 10px;
        right: 10px;
        text-align: right;
        cursor: pointer;

        .controls {
          margin: 10px;
          background: #fff;
          width: 84px;
          height: 100%;
          border-radius: 4px;
          span {
            display: block;
            height: 30px;
            line-height: 30px;
            text-align: center;
          }
        }

        img {
          width: 26px;
          height: 26px;
          margin-right: 10px;
        }

        .import-btn {
          width: 56px;
          height: 26px;
          font-size: 13px;
          color: #fff;
          border-radius: 13px;
          background: #000;
          opacity: .6;
          padding: 4px 10px;
        }
        .grey {
          cursor: no-drop;
          background: #ccc;
          opacity: 1;
          color: #fff;
        }
      }

      img {
        width: 240px;
        height: 426px;
        border-radius: 10px;
        object-fit: cover;
        object-position: top;
        &.active-item {
          border: 2px solid #236dff;
          border-radius: 10px;
        }
      }
      /deep/.ivu-checkbox-checked .ivu-checkbox-inner {
        background: #000;
        opacity: .6;
        border-color: none;
      }
    }
  }

  .posterTitle {
    position: relative;
    max-width: 240px;
    margin-top: 12px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    .title {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    img {
      width: 17px;
      height: 20px;
      margin-bottom: 10px;
      margin-left: 5px;
    }
  }

  .check-group {
    position: absolute;
    top: 10px;
    left: 10px;
  }
}
.my-modal {
  .tips {
    display: block;
    margin-top: 20px;
    margin-bottom: 15px;
    color: #727c8e;
  }
}
.writingTitle {
  margin-top: 30px;
  margin-bottom: 10px;
  width: 100%;
  text-align: center;
  font-weight: 500;
  line-height: 20px;
  color: #3c464f;
}

.writingContent {
  font-size: 13px;
  line-height: 20px;
  color: #515c6f;
}
.import-container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .import-title {
    margin: 0 120px;
    font-size: 10px;
    margin-top: 32px;
    margin-bottom: 24px;
    text-align: center;
    color: #3c464f;
    font-size: 15px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .img > img {
    width: 360px;
    height: 500px;
    object-fit: contain;
    border-radius: 10px !important;
  }
}
</style>
